import dayjs from 'dayjs';
import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';

export class DateBox extends React.Component {
  static propTypes = {
    locale: PropTypes.string
  };

  render() {
    const { locale } = this.props;

    if (!_.isEmpty(locale)) {
      dayjs.locale(locale); /* sets the localization */
    }

    const date = dayjs(this.props.date);
    const { color } = this.props;
    let mm;
    let ddd;
    let dateNumber;

    mm = date.format('MMM');
    ddd = date.format('ddd');
    dateNumber = date.date();

    return (
      <div style={{ borderColor: color }} className="sc-assignment-date-box ">
        <div className="calendar-top-lines">
          <span style={{ background: color }} className="calendar-top-line" />
          <span style={{ background: color }} className="calendar-top-line" />
          <span style={{ background: color }} className="calendar-top-line" />
        </div>
        <div style={{ background: color }} className="sc-assignment-date-box-month">
          {mm}
        </div>
        <div className="sc-assignment-date-box-body">
          <div className="sc-assignment-date-box-day-name">{ddd}</div>
          {dateNumber}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    locale: state.i18n.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DateBox);
